import { tagStyles } from "@/mocks/site";

interface TagBadgeProps {
  tag: string;
  className?: string;
}

export default function TagBadge({ tag, className = "" }: TagBadgeProps) {
  const style = tagStyles[tag] || "bg-secondary-100 text-secondary-900";
  return (
    <span
      className={`inline-flex h-5 w-5 items-center justify-center rounded-sm font-heading text-xs font-bold ${style} ${className}`}
    >
      {tag}
    </span>
  );
}